		const utilityBar = document.getElementById('utilityBar') ?? null;
		const contentArea = document.getElementById('contentArea') ?? null;

		function updatePosition() {
			if (utilityBar && contentArea) {
				const rect = contentArea.getBoundingClientRect();
				if (rect.bottom <= window.innerHeight) {
					utilityBar.style.position = 'absolute';
					utilityBar.style.bottom = '-3rem';
					utilityBar.style.top = 'auto';
				} else if (rect.top <= window.innerHeight && rect.bottom >= window.innerHeight) {
					utilityBar.style.position = 'fixed';
					utilityBar.style.bottom = '0';
					utilityBar.style.top = 'auto';
				} else {
					utilityBar.style.position = 'fixed';
					utilityBar.style.bottom = '0';
					utilityBar.style.top = 'auto';
				}
			}
		}

		window.addEventListener('scroll', updatePosition);
		window.addEventListener('resize', updatePosition);

		updatePosition();